import { BrowserModule } from "@angular/platform-browser";
import { ErrorHandler, NgModule, APP_INITIALIZER } from "@angular/core";
import { AppRoutingModule } from "./app.router";
import { NgxSpinnerModule } from "ngx-spinner";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from "@angular/common/http";
import { BugReportService } from "./shared/services/bug-report/bug-report.service";
import { BugReportInterceptor } from "./shared/interceptors/bug-report.interceptor";

import { SharedModule } from "./shared/shared.module";

import { AppComponent } from "./app.component";
import { LoginComponent } from "./login/login.component";
import { HeaderComponent } from "./header/header.component";
import { SidebarComponent } from "./sidebar/sidebar.component";
import { HomeComponent } from "./home/home.component";
import { CommonModule } from "@angular/common";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ToastrModule } from "ngx-toastr";

import { homeService } from "./home/home.service";
import { authenticationService } from "./login/auth.service";
import { BillAddressService } from "./billAddress/shared/billAddress.service";

import { DatePipe } from "@angular/common";
import { ConfirmationService, MessageService } from "primeng/api";
import { ToastModule } from "primeng/toast";
import { TooltipModule } from "primeng/tooltip";
import { ProgressSpinnerModule } from "primeng/progressspinner";

import { ProductSelectFormatResolver } from "./product/shared/productSelectFormat.resolver";
import { ProductsResolver } from "./product/shared/products.resolver";


import { ClientsResolver } from "./client/shared/client.resolver";

import { ChargeTypesResolver } from "./chargeType/shared/chargetypes.resolver";
import { ChargeTypesIdResolver } from "./chargeType/shared/chargeTypesId.resolver";
import { GlobalChargeTypesResolver } from "./chargeType/shared/globalchargetypes.resolver";
import { EquipmentResolver } from "./equipment/shared/equipment.resolver";
import { CurrencyPipe } from "@angular/common";
import { NotFoundComponent } from "./not-found/not-found.component";
import { SchedulingTeamsComponent } from "./scheduling-teams/scheduling-teams.component";
import { NewTripService } from "./trip-new/shared/trip.service";

import { InputMaskModule as NeatInputMaskModule } from "@ngneat/input-mask";
import { ResetComponent } from "./login/reset.component";
import { RaygunErrorHandler } from "../raygun";
import {
  GoogleMapsLoaderService,
  initializeGoogleMaps,
} from "@app/shared/services/google-maps-loader.service";

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ResetComponent,
    HeaderComponent,
    SidebarComponent,
    HomeComponent,
    NotFoundComponent,
    SchedulingTeamsComponent,
  ],
  bootstrap: [AppComponent],
  imports: [
    CommonModule,
    SharedModule,
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      timeOut: 8000,
      maxOpened: 9,
      autoDismiss: true,
    }),
    ReactiveFormsModule,
    NgxSpinnerModule,
    NeatInputMaskModule.forRoot({ inputSelector: "input", isAsync: true }),
    ToastModule,
    TooltipModule,
    ProgressSpinnerModule,
  ],
  providers: [
    homeService,
    authenticationService,
    //AccessorialService,
    BillAddressService,
    ProductSelectFormatResolver,
    ProductsResolver,
    ClientsResolver,
    ChargeTypesResolver,
    ChargeTypesIdResolver,
    GlobalChargeTypesResolver,
    EquipmentResolver,
    CurrencyPipe,
    DatePipe,
    ConfirmationService,
    MessageService,
    NewTripService,
    GoogleMapsLoaderService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeGoogleMaps,
      deps: [GoogleMapsLoaderService],
      multi: true,
    },
    {
      provide: ErrorHandler,
      useClass: RaygunErrorHandler,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: BugReportInterceptor,
      multi: true,
    },
    BugReportService,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
